import { render, staticRenderFns } from "./PoyntingVectorViz.vue?vue&type=template&id=441f1432&scoped=true"
import script from "./PoyntingVectorViz.vue?vue&type=script&lang=js"
export * from "./PoyntingVectorViz.vue?vue&type=script&lang=js"
import style0 from "./PoyntingVectorViz.vue?vue&type=style&index=0&id=441f1432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f1432",
  null
  
)

export default component.exports